// extracted by mini-css-extract-plugin
module.exports = {"Disabled":"Message_Disabled__3e-lz","Info":"Message_Info__1BcEE"};